var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderMember',{attrs:{"header":"เพิ่มลูกค้าส่งเครดิต","img_header":_vm.header_image,"link_back":"customer"}}),_c('AddCustomer_Credit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }